module.exports = __webpack_public_path__ + "img/ko_number_04.00c13a1c.svg";